import Vue from "vue";
import App from "./App.vue";
// import router from "./router";

import router from "./router";
import { store } from "./_store";
import { isAuthenticated } from "./_services/authentication.service";

import "./plugins/axios";
import "./plugins/iview";

import "./assets/css/style.css";

export const bus = new Vue();

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.matched.length) {
    if (to.meta.requiredAuth) {
      if (isAuthenticated()) {
        next();
      } else {
        next({ name: "Login" });
      }
    } else {
      next();
    }
  }else {
    next({name: '404'});
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
